import { NeoModel, ModelBase } from '@singularsystems/neo-core';
@NeoModel
export default class TransactionDetailLookup extends ModelBase {
    public eventDate: string | null = null;

    public clientNumber: string = "";

    public stockbrokerAccount: string = "";

    public eventName: string = "";

    public eventID: string = "";

    public relatedEventID: string = "";

    public instrumentDescription: string = "";

    public ticker: string = "";

    public isin: string = "";

    public currency: string = "";

    public amount: number = 0;

    public amountUSD: number = 0;

    public quantity: number | null = null;

    public isExcludedInd: boolean = false;

    public portfolioQuantity: number | null = null;

    public costOfSale: number | null = null;

    public purchaseCost: number | null = null;

    public portfolioBookCost: number | null = null;

    public costOfSaleUSD: number | null = null;

    public purchaseCostUSD: number | null = null;

    public portfolioBookCostUSD: number | null = null;

    public weightedAverageCostID : number |null = null;
}